export const getSoccerBasePath = () => {
  return process.env.GATSBY_STAGE !== "production" ? "/adisoccer/" : "/";
};
